import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";


export type AlertType = 'error' | 'warn' | 'success' | 'info';

@Injectable({
  providedIn: 'root'
})

export class AlertaService {

  public show$ = new BehaviorSubject(false);
  public decision$ = new BehaviorSubject(false);
  public message$ = new BehaviorSubject('');
  public title$ = new BehaviorSubject('');
  public type$ = new BehaviorSubject('');

  private confirmCallback: () => void = () => { };
  private cancelCallback: () => void = () => { };


  openAlerta(title: string, message: string, type: AlertType) {
    this.resetCallbacks();
    this.message$.next(message);
    this.title$.next(title);
    this.type$.next(type);
    this.show$.next(true);
    this.decision$.next(false);
  }

  openAlertaConfirmacion(title: string, message: string, type: AlertType, onConfirm: () => void) {
    this.resetCallbacks();
    this.message$.next(message);
    this.title$.next(title);
    this.type$.next(type);
    this.cancelCallback = onConfirm;
    this.show$.next(true);
    this.decision$.next(false);
  }

  openAlertaDesicion(title = '', message: string, type: AlertType, onConfirm: () => void, onCancel?: () => void) {
    this.resetCallbacks();
    this.message$.next(message);
    this.title$.next(title);
    this.type$.next(type);
    this.confirmCallback = onConfirm;
    this.cancelCallback = onCancel || (() => { });
    this.show$.next(true);
    this.decision$.next(true);
  }

  confirm() {
    const callback = this.confirmCallback;
    this.show$.next(false);
    this.resetCallbacks();
    callback();
  }

  cancel() {
    const callback = this.cancelCallback;
    this.show$.next(false);
    this.resetCallbacks();
    callback();
  }

  private resetCallbacks(): void {
    this.confirmCallback = () => { };
    this.cancelCallback = () => { };
  }

}
